<style>
@import url("https://fonts.googleapis.com/css2?family=Lora:wght@500&display=swap");
body {
  padding: 0;
  margin: 0;
  background-color: #607025 !important;
  font-family: "Lora", serif;
}
.bg-green {
  background-color: #46521b !important;
}
.container {
  font-family: "Lora", serif;
}
* {
  scrollbar-width: thin;
  scrollbar-color: #313a14 #505d1f;
}

/* Works on Chrome, Edge, and Safari */
*::-webkit-scrollbar {
  width: 12px;
}

*::-webkit-scrollbar-track {
  background: #505d1f;
}

*::-webkit-scrollbar-thumb {
  background-color: #313a14;
  border-radius: 20px;
  border: 3px solid #505d1f;
}
</style>

<template>
  <div class="container bg-green">
    <header class="bgimg bg-green text-white">
      <div class="row gx-5">
        <div class="col-lg-6">
          <img src="img/nuestrahistoria_upaep.jpg" width="100%" />
        </div>
        <div class="col-lg-6">
          <div class="text-center my-5">
            <img src="img/logo_nuestra.jpg" width="33%" class="py-3" />
            <h1 class="display-5 fw-bolder mb-2 py-3">
              De agosto a diciembre 2021
            </h1>
            <!-- <p class="lead text-white-50 mb-4">
              Lorem ipsum dolor sit amet, consectetuer adipiscing elit
            </p> -->
            <hr />
            <div class="d-grid gap-3 d-sm-flex justify-content-sm-center">
              <a
                class="btn btn-outline-light btn-lg px-4 me-sm-3"
                href="#/game"
              >
                Juego
              </a>
              <a class="btn btn-outline-light btn-lg px-4" href="#/view360">
                Recorrido 360
              </a>
            </div>
          </div>
        </div>
      </div>
    </header>
    <section class="py-5 bg-white border-bottom" id="features">
      <div class="container px-5 my-5">
        <div class="row gx-5">
          <div class="col-lg-6 mb-5 mb-lg-0">
            <h2 class="h4 fw-bolder">Recursos para profesores</h2>
            <p>
              En este apartado podrás acceder a recursos adicionales para el
              mejor aprovechamiento de esta exposición.
            </p>
            <p>
              Si deseas contactarnos, puedes enviar un correo a
              <a target="_blank" href="mailto:museo@upaep.mx">museo@upaep.mx</a>
            </p>
            <ul>
              <!-- <li>
                <button type="button" class="btn btn-success">Success</button> <br>
              </li> -->
              <li>
                <a href="recursos_pdf/Cuadernillo_para_docentes.pdf" target="_blank">Cuadernillo para docentes</a>
                <br />
              </li>
              <li>
                <a href="https://docs.google.com/forms/d/e/1FAIpQLScP6NwPpFSSqebwQXqLgTleJN17MOyF5qhv2BWfAy-jg8Oipg/viewform" target="_blank">Reserva tu visita guiada aquí</a>
                <br />
              </li>
              <li>
                <a href="recursos_pdf/PLAN_DE_IGUALA_EN_LA_ABEJA_POBLANA.pdf" target="_blank">Plan de iguala en la abeja poblana</a>
                <br />
              </li>
              <li>
                <a href="recursos_pdf/ACTA_DE_INDEPENDENCIA_DEL_IMPERIO_MEXICANO.pdf" target="_blank">Acta de independencia del imperio mexicano</a>
                <br />
              </li>
            </ul>
          </div>
          <div class="col-lg-6 mb-5 mb-lg-0 text-center">
            <img src="img/patrocinadores.png" class="w-50 float-center" />
          </div>
        </div>
      </div>
    </section>
    <wafloater phone="++5212212570586"/>
  </div>
</template>

<script>
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import Popper from "@popperjs/core";
import Wafloater from "@/components/Wafloater.vue";

export default {
  name: "Main",
  components: {
    Wafloater
  }
};
</script>
